 <template>
 <div class="mx-auto">
   <emptyState v-if='showEmptyState' src='https://firebasestorage.googleapis.com/v0/b/dynamo-stage-251122.appspot.com/o/undraw_relaxation_1_wbr7.svg?alt=media&token=7a8f39d0-3679-449b-addc-168acd76cc94' message='no new task, sit back and relax'/>
  <v-card v-else>
    <v-overlay absolute :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-toolbar
      color="cyan"
      dark
    >
      <v-toolbar-title><v-icon class='mr-2'>person</v-icon>New Users</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click='getUserTasks()'>
        <v-icon title='refresh the list' >refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-list two-line>
      <template v-for="(Useritem, index) in taskListValue">
        <v-list-item
          :key="index"
        >
          <v-list-item-content>
            <v-list-item-title title='peak this task'> User Email: {{Useritem.info.email}}<v-icon @click='taskPeak(Useritem)'>remove_red_eye</v-icon></v-list-item-title>
            <v-list-item-subtitle>Name: {{Useritem.info.name}}</v-list-item-subtitle>
          </v-list-item-content>
           <v-list-item-action>
           <assignToButton :userUID='Useritem.uid' />
        </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
  <viewMessage v-if='messageId' @clickoutside='messageId=null' :messageId='messageId' :taskid='taskid'/>
 </div>
</template>


<script>
import emptyState from '../components/EmptyState'
import { mapFields } from 'vuex-map-fields';
import { postReq ,getnewUsers} from '../helper/firestore'
import viewMessage from '../components/message/viewMessage'
import assignToButton from "../components/assignToButton";
export default {
  props : {
    taskList : Array,
  },
    data () {
    return {
      taskListValue : null,
      showEmptyState : false,
        overlay : true,
        messageId : null,
        messagesList : null,
        taskid : null,
    }
  },
  mounted () {
    
  },
  watch: { 
    taskList: function(newVal) {
      this.taskListValue = newVal
           this.overlay = false;
        }
      },
  methods: {
    assignTo(userItem,gcitem){
       postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/assignUsertoGC',{uid:  userItem.uid, gcID : gcitem.uid,gcEmail : gcitem.email},()=>{
        
        })


    },
    taskPeak(item){
     this.$router.push("/user/email/"+ item.info.email+"#peak");
    },
    icon(type){
     return "person_add"
    },
        getUserTasks(){
           this.overlay = true;
           getnewUsers(this.user.idToken,result=>{
          this.taskListValue = result
          this.overlay = false;

    })
    },

  },
    components: {
      emptyState,viewMessage,assignToButton
  },
  computed: {
    ...mapFields([
      'admins',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
  },
}
</script>